'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import InquiryForm from './InquiryForm';
// import LiveChatWidget from './LiveChatWidget';
// import SupportTicketSystem from './SupportTicketSystem';

type TabType = 'inquiry' | 'chat' | 'ticket';

export default function ContactPageInteractive() {
  const [activeTab, setActiveTab] = useState<TabType>('inquiry');
  const [isChatOpen, setIsChatOpen] = useState(false);

const tabs = [
    //{ id: 'inquiry' as TabType, label: 'Send Inquiry', icon: 'EnvelopeIcon' },
   //{ id: 'chat' as TabType, label: 'Live Chat', icon: 'ChatBubbleLeftRightIcon' },
    //{ id: 'ticket' as TabType, label: 'Support Ticket', icon: 'DocumentTextIcon' }
  ];

  return (
    <div className="min-h-screen bg-background pt-16">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-secondary text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Get in Touch
            </h1>
            <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
              We're here to help you with your study abroad journey. Choose your preferred way to connect with us.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="py-12 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 -mt-20">
            <div className="bg-card rounded-lg shadow-elevated p-6 border border-border">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="PhoneIcon" size={24} className="text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-foreground">Call Us</h3>
              </div>
              <span className="cursor-pointer hover:text-primary"><a href="tel:+917966826611">+91 79668 26611</a></span><br/>
              <p className="text-muted-foreground text-sm mb-2">Mon-Sat: 10:00 - 18:30</p>
              
            </div>

            <div className="bg-card rounded-lg shadow-elevated p-6 border border-border">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center">
                  <Icon name="EnvelopeIcon" size={24} className="text-secondary" />
                </div>
                <h3 className="text-lg font-semibold text-foreground">Email Us</h3>
              </div>
              <span className="cursor-pointer hover:text-primary"><a href="mailto:info@yunovainternational.com">info@yunovainternational.com</a></span><br/>
              <p className="text-muted-foreground text-sm mb-2">We'll respond within 24 hours</p>
              
            </div>

            <div className="bg-card rounded-lg shadow-elevated p-6 border border-border">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
                  <Icon name="MapPinIcon" size={24} className="text-accent" />
                </div>
                <h3 className="text-lg font-semibold text-foreground">Visit Us</h3>
              </div>
              <p className="text-muted-foreground text-sm mb-2">Main Office</p>
              <span className="cursor-pointer hover:text-primary"><a href="https://maps.app.goo.gl/CcKXLtbE2zvNWsSH8">203, 2nd Floor, Sun Orbit, Rajpath Rangoli Road, near Pandit Dindayal Hall, Bodakdev, Ahmedabad, Gujarat 380059</a></span><br/>
            </div>
          </div>
        </div>
      </section>

      {/* Tab Navigation */}
      <section className="py-8 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-4 justify-center mb-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-semibold transition-all duration-smooth ${
                  activeTab === tab.id
                    ? 'bg-primary text-primary-foreground shadow-elevated'
                    : 'bg-card text-foreground border border-border hover:border-primary hover:shadow-subtle'
                }`}
              >
                <Icon name={tab.icon} size={20} />
                <span>{tab.label}</span>
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="animate-fade-in">
            {activeTab === 'inquiry' && <InquiryForm />}
            {activeTab === 'chat' && <LiveChatWidget />}
            {activeTab === 'ticket' && <SupportTicketSystem />}
          </div>
        </div>
      </section>

      {/* Floating Chat Button */}
      <button
        onClick={() => {
          setActiveTab('chat');
          setIsChatOpen(true);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
        className="fixed bottom-6 right-6 w-14 h-14 bg-primary text-primary-foreground rounded-full shadow-elevated hover:shadow-hover flex items-center justify-center transition-all duration-smooth hover:scale-110 z-40"
        aria-label="Open live chat"
      >
        <Icon name="ChatBubbleLeftRightIcon" size={24} />
      </button>
    </div>
  );
}